/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ForcingSubstance } from "./ForcingSubstance";
import {
  ForcingSubstanceFromJSON,
  ForcingSubstanceFromJSONTyped,
  ForcingSubstanceToJSON,
  ForcingSubstanceToJSONTyped,
} from "./ForcingSubstance";
import type { LateralUnitsEnum } from "./LateralUnitsEnum";
import {
  LateralUnitsEnumFromJSON,
  LateralUnitsEnumFromJSONTyped,
  LateralUnitsEnumToJSON,
  LateralUnitsEnumToJSONTyped,
} from "./LateralUnitsEnum";
import type { Point } from "./Point";
import { PointFromJSON, PointFromJSONTyped, PointToJSON, PointToJSONTyped } from "./Point";
import type { EventStateEnum } from "./EventStateEnum";
import {
  EventStateEnumFromJSON,
  EventStateEnumFromJSONTyped,
  EventStateEnumToJSON,
  EventStateEnumToJSONTyped,
} from "./EventStateEnum";

/**
 * EventMixin which converts a timeseries-event into a contstant-event.
 *
 * Behind the scenes constant and timeseries are the same but shown to the user as 2
 * different types for ease of configuration.
 * In a constant-event the user provides a `value` and `duration`, whereas in a
 * timeseries-event the user provides nested array as `values`. This mixin converts
 * the `value` and `duration` of a constant-event into a timeseries similar as a
 * timeseries event.
 *
 * The timeseries will look as following:
 * `values = [[0, value], [duration, 0]]`
 *
 * Requires the fields:
 * - interpolate
 * - constant
 * - value
 * - values
 * - duration
 * @export
 * @interface ConstantLateral
 */
export interface ConstantLateral {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   * offset of event in simulation in seconds
   */
  offset: number;
  /**
   * event duration in seconds. -9999 is the 'infinite duration' value (only allowed in conjunction with infinite simulations
   */
  duration: number | null;
  /**
   *
   */
  value: number;
  /**
   * 'm3/s' (only option for now)
   *
   * * `m3/s` - m3/s
   */
  units: LateralUnitsEnum;
  /**
   *
   */
  point?: Point;
  /**
   *
   */
  connectionNode?: number | null;
  /**
   *
   */
  readonly state?: EventStateEnum;
  /**
   *
   */
  readonly stateDetail?: any | null;
  /**
   *
   */
  readonly gridId?: number | null;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  substances?: Array<ForcingSubstance>;
}

/**
 * Check if a given object implements the ConstantLateral interface.
 */
export function instanceOfConstantLateral(value: object): value is ConstantLateral {
  if (!("offset" in value) || value["offset"] === undefined) return false;
  if (!("duration" in value) || value["duration"] === undefined) return false;
  if (!("value" in value) || value["value"] === undefined) return false;
  if (!("units" in value) || value["units"] === undefined) return false;
  return true;
}

export function ConstantLateralFromJSON(json: any): ConstantLateral {
  return ConstantLateralFromJSONTyped(json, false);
}

export function ConstantLateralFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ConstantLateral {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    offset: json["offset"],
    duration: json["duration"],
    value: json["value"],
    units: LateralUnitsEnumFromJSON(json["units"]),
    point: json["point"] == null ? undefined : PointFromJSON(json["point"]),
    connectionNode:
      json["connection_node"] === undefined
        ? undefined
        : json["connection_node"] === null
        ? null
        : json["connection_node"],
    state: json["state"] == null ? undefined : EventStateEnumFromJSON(json["state"]),
    stateDetail:
      json["state_detail"] === undefined
        ? undefined
        : json["state_detail"] === null
        ? null
        : json["state_detail"],
    gridId:
      json["grid_id"] === undefined ? undefined : json["grid_id"] === null ? null : json["grid_id"],
    uid: json["uid"] == null ? undefined : json["uid"],
    id: json["id"] == null ? undefined : json["id"],
    substances:
      json["substances"] == null
        ? undefined
        : (json["substances"] as Array<any>).map(ForcingSubstanceFromJSON),
  };
}

export function ConstantLateralToJSON(json: any): ConstantLateral {
  return ConstantLateralToJSONTyped(json, false);
}

export function ConstantLateralToJSONTyped(
  value?: Omit<
    ConstantLateral,
    "url" | "simulation" | "state" | "stateDetail" | "gridId" | "uid" | "id"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    offset: value["offset"],
    duration: value["duration"],
    value: value["value"],
    units: LateralUnitsEnumToJSON(value["units"]),
    point: PointToJSON(value["point"]),
    connection_node: value["connectionNode"],
    substances:
      value["substances"] == null
        ? undefined
        : (value["substances"] as Array<any>).map(ForcingSubstanceToJSON),
  };
}
